import React, { useContext, useEffect, useRef, useState } from 'react'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { CalendarIcon, PencilIcon } from './assets'
import { MAX_FUTURE_DATE_DAYS } from '../../../Constants'
import './styles.scss'

export default () => {
  const { subscriptionStartTime, changeStartingDate } = useContext(BuyingInsuranceContextStore)
  const today = new Date(new Date()) //.toDateString())
  const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + MAX_FUTURE_DATE_DAYS)

  const handleOnChange = value => {
    changeStartingDate(new Date(value))
  }

  const isInvalidDate =
    new Date(subscriptionStartTime.toDateString()) < new Date(today.toDateString()) ||
    new Date(subscriptionStartTime.toDateString()) > new Date(maxDate.toDateString())
  return (
    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', height: '2rem', padding: '0 .5rem' }}>
      <CalendarIcon />
      <div style={{ marginLeft: '.4rem' }}>Starting Date</div>
      <div style={{ marginLeft: 'auto', position: 'relative' }}>
        <span style={{ marginRight: '0.2rem', textDecoration: 'underline', ...(isInvalidDate && { color: 'red' }) }}>
          {subscriptionStartTime.toLocaleDateString()}
        </span>
        <PencilIcon />
        <input
          type="date"
          value={subscriptionStartTime.toISOString().slice(0, 10)}
          min={today.toJSON().split('T')[0]}
          max={maxDate.toJSON().split('T')[0]}
          onChange={e => handleOnChange(e.target.valueAsDate)}
        />
      </div>
    </div>
  )
}
